import { Select } from "element-ui";

export const tableOption = {
    border: true,
    stripe: true,
    menuAlign: 'center',
    editBtn: false,
    delBtn: false,
    align: 'center',
    addBtn: false,
    columnBtn: false,
    menu:false,
    page:false,
    column: [
    {
      label: '时间段',
      prop: 'dateTimeDisplay',
      span: 24,
    },
    {
        label: '帖子量',
        prop: 'totalPostCount',
        span: 24,
    },
    {
        label: '评论量',
        prop: 'totalCommentCount',
        span: 24,
    },
    {
        label: '点赞量',
        prop: 'totalLikeCount',
        span: 24,
    },
    {
        label: '收藏量',
        prop: 'totalFavoriteCount',
        span: 24,
    },
    {
        label: '浏览量',
        prop: 'totalViewCount',
        span: 24,
    // },
    // {
    //   label: 'UV',
    //   prop: 'totalUniqueViewCount',
    //   span: 24,
    }]
}